import api from './api';

export interface BankStatement {
  id: number;
  bank_name: string | null;
  account_number: string | null;
  statement_number: string | null;
  opening_balance: number | null;
  closing_balance: number | null;
  opening_date: string | null;
  closing_date: string | null;
  currency: string;
  transaction_count: number;
  total_debit: number;
  total_credit: number;
  source_filename: string | null;
  imported_by_user_id: string | null;
  imported_at: string;
  transaction_count_actual: number;
  reconciled_count: number;
}

export interface BankStatementTransaction {
  id: number;
  transaction_ref: string | null;
  statement_id: number;
  value_date: string | null;
  booking_date: string | null;
  direction: 'C' | 'D' | 'RC' | 'RD';
  amount: number;
  transaction_code: string | null;
  reference: string | null;
  bank_ref: string | null;
  counterparty_name: string | null;
  counterparty_account: string | null;
  title: string | null;
  additional_info: string | null;
  transaction_type: 'regular' | 'split_payment';
  split_payment_role: 'vat_transfer' | 'payment' | null;
  vat_amount: number | null;
  counterparty_nip: string | null;
  invoice_number: string | null;
  tnr: string | null;
  operation_code: string | null;
  bank_operation_id: number | null;
  reconciled_at: string | null;
  reconciled_by_user_id: string | null;
  // Joiny
  statement_number: string | null;
  bank_name: string | null;
  statement_account: string | null;
  statement_currency: string | null;
  source_filename: string | null;
}

export async function listBankStatements(): Promise<BankStatement[]> {
  const { data } = await api.get('/bank-statements');
  return data?.data || [];
}

export async function listBankStatementTransactions(): Promise<BankStatementTransaction[]> {
  const { data } = await api.get('/bank-statements/transactions');
  return data?.data || [];
}

export async function importMT940(file: File, bankName?: string): Promise<{ statementIds: number[]; count: number }> {
  const formData = new FormData();
  formData.append('file', file);
  if (bankName) formData.append('bank_name', bankName);
  const { data } = await api.post('/bank-statements/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data?.data || { statementIds: [], count: 0 };
}

export async function deleteBankStatement(id: number | string): Promise<void> {
  await api.delete(`/bank-statements/${id}`);
}
